import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly messageService = inject(MessageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const action = request.headers.get('frontend-action') || null;

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let summary: string = `Algo ha fallado`;
        const payload = this.getErrorPayload(error);
        let details = this.getDetails(payload.message);

        switch (payload.code) {
          case 'DOCUMENT_REVIEW_PENDING':
            summary = 'Documento en revisión';
            details = [
              this.getDetails(payload.message)[0] ??
                'El documento está en revisión manual y no puede reemplazarse por ahora.',
            ];
            break;
          case 'DOCUMENT_ALREADY_APPROVED':
            summary = 'Documento aprobado';
            details = [
              this.getDetails(payload.message)[0] ??
                'El documento ya fue aprobado y no puede reemplazarse.',
            ];
            break;
        }

        if (error.status === 403 && payload.caseCode) {
          summary = 'Validación PLAFT observada';
          details = [
            `${this.getDetails(payload.message)[0] ?? 'No es posible continuar con el registro.'} Código de caso: ${payload.caseCode}`,
          ];
        }

        switch (error.status) {
          case 400:
            summary = `Aviso`;
            break;
        }

        const messages = details.map((detail): ToastMessageOptions => {
          return {
            severity: 'error',
            summary,
            // summary: index === 0 ? summary : undefined,
            detail,
            // sticky: true,
            life: 3500,
          };
        });

        if (action !== 'silence') this.messageService.addAll(messages);

        return throwError(() => error);
      })
    );
  }

  private getErrorPayload(error: HttpErrorResponse): {
    message?: string | string[];
    code?: string;
    caseCode?: string;
  } {
    const payload = error.error;
    return typeof payload === 'object' && payload !== null ? payload : {};
  }

  private getDetails(message: string | string[] | undefined): string[] {
    if (Array.isArray(message)) return message;
    return [message ?? 'Sin datos.'];
  }
}
